<template>
    <div>
        <v-container app :fluid="true" class="pt-0 pb-0">
            <v-row>
                <v-col cols="12" class="pt-0 pr-0">
                    <v-text-field
                        :value="search"
                        @input="handleSearchProducto"
                        label="Buscar producto por nombre o código de barras"
                        dense                       
                        solo
                        autofocus
                        hide-details
                        prepend-inner-icon="fas fa-search"
                        class="wost-text-input mr-2"
                        @keydown="handleInputSearchProduct">
                    </v-text-field>                    
                </v-col>
                <!--
                <v-col cols="2" class="pt-0 pl-0">
                    <v-btn-toggle
                        v-model="type_view"
                        mandatory
                        dense
                        >
                        <v-btn class="btn-show-mode">
                            <v-icon size="18">fas fa-bars</v-icon>
                        </v-btn>
                        <v-btn class="btn-show-mode">
                            <v-icon size="18">fas fa-border-all</v-icon>
                        </v-btn>
                    </v-btn-toggle>
                </v-col>
                -->
            </v-row>
            <v-row>
                <v-col cols="12" class="padding-top-0 padding-bootom-0">
                    <v-card>
                        <v-container app :fluid="true" class="list-products-available">
                            <v-row v-if="type_view === 0">                            
                                <v-col cols="12" class="padding-top-0">
                                    <v-card flat>
                                        <v-list-item-group>
                                            <v-list-item two-line v-for="product in availableProducts" :key="product.id"
                                                @click="handleSelectProduct(product)"
                                                class="sales-item-catalogue"
                                                color="indigo"
                                                :disabled="!verifyPermission('seleccionar_producto_pedido')">
                                                <v-list-item-content>
                                                    <v-list-item-title class="sales-name-product-list">
                                                        {{ product.name }}
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle class="sales-price-list">
                                                        <span class="sales-price-label-list">
                                                           <v-icon size="18" class="mr-1" color="red darken-1">fas fa-tags</v-icon>Precio: 
                                                        </span>
                                                        <span class="sales-price-value-list ml-2">
                                                            {{ product.unit_price | currency('S/ ') }}
                                                        </span>                                                        
                                                    </v-list-item-subtitle>                                        
                                                </v-list-item-content>                                                                             
                                            </v-list-item>                                        
                                        </v-list-item-group>
                                    </v-card>                             
                                </v-col>
                            </v-row>
                            <v-row v-else>
                                <v-col cols="3" v-for="product in availableProducts" :key="product.id" class="padding-top-0">
                                    <v-card 
                                        :disabled="!verifyPermission('seleccionar_producto_pedido')"
                                        @click="handleSelectProduct(product)" class="card-product">
                                        <v-img
                                            src="https://cdn.vuetifyjs.com/images/cards/sunshine.jpg"
                                            height="100px">
                                        </v-img>
                                        <v-card-title class="sales-name-product-card">
                                            {{ product.name }}
                                        </v-card-title>
                                        <v-card-subtitle class="sales-price-product-card">
                                            {{ product.unit_price | currency('S/ ') }}
                                        </v-card-subtitle>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <custom-product ref="customProduct"></custom-product>
    </div>
</template>

<script>

import { mapActions, mapMutations, mapState } from 'vuex';
import {BarCodeSupport} from '@/plugins/BarCodeSupport';
import CustomProduct from './CustomProduct';

export default {
    name: 'Products',
    components: {
        CustomProduct
    },
    data() {
        return {
            type_view: 0,
        }
    },
    computed: {
        ...mapState('sales', [
            'catalogue',
            'search',
            'availableProducts',
            'product',
            'selectedProducts'
        ])
    },
    methods: {
        ...mapMutations('sales', [
            'setCatalogue',
            'setSearch',
            'setShowProduct',
            'setProduct',            
        ]),
        ...mapActions('sales', [
            'getCatalogue',
            'searchProduct',
            'selectProduct'
        ]),
        handleSelectProduct(product){
            let unit_price = parseFloat(product.unit_price);
            if (unit_price > 0) {
                this.setProduct(product);
                this.selectProduct();
            } else {
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'AGREGAR PRODUCTOS',
                    text: 'No puede agregar productos cuyo precio es menor o igual a 0'
                });
            }            
        },
        handleSearchProducto(event){
            let product = event.toUpperCase();
            this.setSearch(product);            
        },
        handleInputSearchProduct(KeyboardEvent){
            if (KeyboardEvent.code == 'Enter') {
                this.searchProductInCatalogue();
            }
        },
        async searchProductInCatalogue () {
            let filter = {
                description: this.search
            }
            await this.getCatalogue(filter);
            if (this.availableProducts.length == 1) {
                if (!this.notBarcode(event)) {
                    let productFounded = Object.assign({}, this.availableProducts[0]);
                    this.setProduct(productFounded);
                    this.selectProduct();
                }                
            }
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        },
        handleCustomProduct () {
            this.$refs.customProduct.show();
        },
        notBarcode (textSearch) {
            let response = true;
            if (textSearch) {
                let value = textSearch.toString();
                if (value.length === 9) {
                    if (/^([0-9])*$/.test(value) === true) {
                        response = false;
                    }
                }
            }

            return response;
        },
        selectBarcode (data) {
            this.handleSearchProducto(data);
        }
    },
    created() {
        this.setSearch(null);
        this.getCatalogue()
    },
    mounted () {
        BarCodeSupport.$on('codeScanned', data => {                
            this.selectBarcode(data)
        });
    }
}
</script>

<style scoped>
.btn-show-mode{
    min-width: 50px !important;
}
</style>